import { wrapInApolloProvider } from 'owa-apollo/lib/react';
import { onCloseHeaderPane } from 'owa-app-pane-group-actions';
import { DrawerPane } from 'owa-drawer';
import type { OwaHeaderPaneProps } from 'owa-header-types';
import { observer } from 'owa-mobx-react';
import {
    TimePanel as LazyTimePanel,
    TimePanelHeaderBar as LazyTimePanelHeaderBar,
} from 'owa-time-panel/lib/lazyCalendarBoot';
import { bodyContainer, header } from './MyDayPane.scss';
import type { FunctionComponent } from 'react';

const onMyDayClosePane = () => {
    onCloseHeaderPane('myDay');
};

const myDayPaneTitle = () => {
    return <LazyTimePanelHeaderBar onClosePanel={onMyDayClosePane} />;
};

const defaultExport: FunctionComponent<OwaHeaderPaneProps> = observer(function MyDayPane(
    props: OwaHeaderPaneProps
) {
    return wrapInApolloProvider(
        <DrawerPane
            paneId={props.paneId}
            headerText={myDayPaneTitle()}
            headerClassName={header}
            bodyClassName={bodyContainer}
            noPadding={true}
            role={'complementary'}
        >
            <LazyTimePanel onClosePanel={onMyDayClosePane} />
        </DrawerPane>
    );
},
'MyDayPane');
export default defaultExport;
